export default {
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.advantages': 'Core Advantages',
  'nav.products': 'Products',
  'nav.products.overview': 'Products Overview',
  'nav.products.cex': 'CEX Exchange',
  'nav.products.rwa': 'RWA Solutions',
  'nav.products.wallet': 'Wallet Products',
  'nav.products.staking': 'Staking Products',
  'nav.products.mining': 'Mining Products',
  'nav.services': 'Services',
  'nav.services.overview': 'Services Overview',
  'nav.services.overseasFund': 'Offshore Fund Setup',
  'nav.services.financialLicensing': 'Financial Licensing',
  'nav.services.overseasCompany': 'Overseas Company Formation',
  'nav.services.mergersAcquisitions': 'Mergers & Acquisitions',
  'nav.news': 'News',
  'nav.contact': 'Contact',
  'nav.cta': 'Get Started',

  'hero.tag': 'Industrial Blockchain & Web3 Full-Stack Solutions',
  'hero.title1': 'Empowering Enterprise Web3',
  'hero.title2': 'Building a Trustworthy Digital Future',
  'hero.subtitle': 'Singapore HQ · Modular Architecture · Technology as a Service',
  'hero.cta1': 'Explore Solutions',
  'hero.cta2': 'View Products',

  'stats.years': '8+',
  'stats.years.label': 'Years Security Experience',
  'stats.clients': '50+',
  'stats.clients.label': 'Enterprise Clients',
  'stats.projects': '200+',
  'stats.projects.label': 'Projects Delivered',
  'stats.support': '24/7',
  'stats.support.label': 'Technical Support',

  'about.tag': 'About Us',
  'about.title': 'Singapore HQ · Global Service',
  'about.desc1': 'We are an industrial blockchain and Web3 innovation company headquartered in Singapore, providing full-stack blockchain solutions for enterprises worldwide.',
  'about.desc2': 'Our team consists of senior blockchain experts, engineers, and Web3 consultants committed to deep integration of the real economy and Web3.',
  'about.desc3': 'Our portfolio covers CEX, RWA tokenization, decentralized wallets, and DApp development, offering full lifecycle services from consulting to operations.',
  'about.badge': 'Singapore Registered',
  'about.badge2': 'Est. 2023',
  'about.more': 'Learn More',

  'services.tag': 'Core Services',
  'services.title': 'Four Core Service Areas',
  'services.cex.title': 'Centralized Exchange (CEX)',
  'services.cex.desc': 'Full-stack CEX with high-performance order matching, KYC/AML compliance, and multi-platform support scalable to millions of TPS.',
  'services.cex.f1': 'High-perf Matching Engine',
  'services.cex.f2': 'KYC/AML Compliance',
  'services.cex.f3': 'Multi-platform PC/H5',
  'services.wallet.title': 'Wallet + IM System',
  'services.wallet.desc': 'Multi-chain decentralized wallet integrated with social IM, supporting DApp browser, NFT management, and DAO governance.',
  'services.wallet.f1': 'Multi-chain Assets',
  'services.wallet.f2': 'DApp Browser',
  'services.wallet.f3': 'NFT Marketplace',
  'services.rwa.title': 'RWA Asset Tokenization',
  'services.rwa.desc': 'Tokenize real estate, art, and supply chains on-chain with compliant ownership, smart contract dividends, and global circulation.',
  'services.rwa.f1': 'Legal Compliance',
  'services.rwa.f2': 'Smart Contract Dividends',
  'services.rwa.f3': 'Qualified Investors',
  'services.dapp.title': 'DApp Custom Development',
  'services.dapp.desc': 'Full-chain DApp development for staking, liquidity mining, GameFi, private placement, social, and more.',
  'services.dapp.f1': 'Staking / Mining',
  'services.dapp.f2': 'GameFi / NFT',
  'services.dapp.f3': 'Private / Dividend',
  'services.more': 'View Details',

  'adv.tag': 'Core Advantages',
  'adv.title': 'Why Choose Us',
  'adv.subtitle': '8+ Years of Industry Expertise, Technology-Driven Web3 Business Enablement',
  'adv.1.num': '01',
  'adv.1.title': 'Modular Architecture',
  'adv.1.desc': 'Highly modular system design with independently deployable modules for rapid iteration and flexible scaling, significantly reducing upgrade costs.',
  'adv.2.num': '02',
  'adv.2.title': 'Complete Chain Ecosystem',
  'adv.2.desc': 'Deep support for Ethereum, BSC, Solana, TRON and more, with complete cross-chain interoperability and multi-chain parallel product matrix.',
  'adv.3.num': '03',
  'adv.3.title': 'Innovation-Driven',
  'adv.3.desc': 'Continuously integrating ZK Proof, Layer2, AI risk management and other frontier technologies to maintain technological leadership.',
  'adv.4.num': '04',
  'adv.4.title': 'Security & Compliance',
  'adv.4.desc': 'Multi-level security audit system compliant with Singapore MAS, Hong Kong SFC and other major jurisdictions for comprehensive trusted assurance.',
  'adv.5.num': '05',
  'adv.5.title': 'Client-Centric Ecosystem',
  'adv.5.desc': 'Dedicated project managers, 24/7 technical support, and ecosystem resource connections focused on client business success.',

  'products.tag': 'Products',
  'products.title': 'Complete Product Matrix',
  'products.subtitle': 'Full lifecycle one-stop support from consulting, development to operations',
  'products.exchange': 'Exchange System',
  'products.rwa': 'RWA Solutions',
  'products.wallet': 'Wallet Products',
  'products.staking': 'Staking Products',
  'products.mining': 'Mining Products',
  'products.more': 'View Details',

  'news.tag': 'Latest News',
  'news.title': 'Industry Updates',
  'news.subtitle': 'Product Updates · Industry Insights · Web3 Frontier',
  'news.more': 'View All',
  'news.read': 'Read More',
  'news.product': 'Product Update',
  'news.industry': 'Industry News',

  'cta.title': 'Ready to Start Your Web3 Journey?',
  'cta.subtitle': 'One-on-one professional consulting from strategy to deployment',
  'cta.btn': 'Contact Us Now',
  'cta.btn2': 'View Product Cases',
  'cta.badge1': 'Singapore Registered',
  'cta.badge2': '8+ Years Experience',
  'cta.badge3': '24/7 Support',
  'cta.badge4': 'Source Code Delivery',

  'footer.about': 'Singapore-based industrial blockchain and Web3 full-stack solution provider, building trustworthy digital infrastructure for enterprises.',
  'footer.links': 'Quick Links',
  'footer.products': 'Products',
  'footer.services': 'Services',
  'footer.contact': 'Contact',
  'footer.address': '160 Robinson Road, #14-04 SBFCenter, Singapore 068914',
  'footer.email': 'info@geelx.com',
  'footer.telegram': 'Telegram: +447849923593',
  'footer.whatsapp': 'WhatsApp: +447849923593',
  'footer.copyright': '© 2026 Geelx.com. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.subscribe': 'Subscribe to Updates',
  'footer.subscribe.placeholder': 'Enter your email',
  'footer.subscribe.btn': 'Subscribe',
  'footer.subscribe.success': 'Subscribed successfully! Thank you for following us.',
  'footer.rss': 'RSS News Feed',
  'rss.feedTitle': 'Geelx News & Insights',
  'rss.subscribe': 'Subscribe via RSS',
  'footer.wechat': 'WeChat: Please scan the QR code',
  'footer.badge.security': 'Security Certified',
  'footer.badge.singapore': 'Singapore Registered',
  'footer.badge.experience': '8+ Years Experience',
  'footer.badge.support': '24/7 Support',

  'breadcrumb.home': 'Home',
  'breadcrumb.about': 'About Us',
  'notFound.title': 'Page Not Found',
  'notFound.subtitle': 'Please check the URL or return to the homepage.',

  'aboutPage.hero.tag': 'About Us',
  'aboutPage.hero.title': 'About Us',
  'aboutPage.hero.highlight': 'Who We Are',
  'aboutPage.hero.subtitle1': 'A Singapore-headquartered industrial blockchain and Web3 full-stack solution provider. ',
  'aboutPage.hero.subtitle2': 'We turn complex blockchain technology into real enterprise productivity.',
  'aboutPage.hero.stats.0.val': '2023',
  'aboutPage.hero.stats.0.label': 'Founded',
  'aboutPage.hero.stats.1.val': 'Singapore',
  'aboutPage.hero.stats.1.label': 'Headquarters',
  'aboutPage.hero.stats.2.val': '8+',
  'aboutPage.hero.stats.2.label': 'Years Experience',
  'aboutPage.hero.stats.3.val': '50+',
  'aboutPage.hero.stats.3.label': 'Enterprise Clients',
  'breadcrumb.news': 'News',
  'newsPage.categories.all': 'All Updates',
  'newsPage.categories.product': 'Product Updates',
  'newsPage.categories.industry': 'Industry News',
  'newsPage.hero.tag': 'News & Insights',
  'newsPage.hero.title': 'News',
  'newsPage.hero.highlight': 'Web3 Frontier Insights',
  'newsPage.hero.desc1': 'Product updates, technical deep dives, and market trend insights.',
  'newsPage.hero.desc2': 'We continuously deliver the latest in Web3 and industrial blockchain.',
  'newsPage.hero.stats.articles': 'Articles',
  'newsPage.hero.stats.categories': 'Categories',
  'newsPage.hero.stats.frequency': 'Monthly',
  'newsPage.hero.stats.monthly': '12+ Posts',
  'newsPage.featured.title': 'Featured Article',
  'newsPage.featured.badge': 'Featured',
  'newsPage.readSuffix': ' read',
  'newsPage.readFull': 'Read Full Article',
  'newsPage.grid.empty': 'No articles in this category yet.',
  'newsPage.grid.total': '{{count}} total',
  'newsPage.grid.loadMore': 'Load more articles ({{remaining}} left)',
  'newsPage.grid.allShown': 'Showing all {{count}} articles',
  'newsDetail.readTime': '{{time}} read',
  'newsDetail.share': 'Share:',
  'newsDetail.related.title': 'Related Articles',
  'newsDetail.summary': 'Article Summary',
  'newsDetail.contactHint': 'Need a business solution? Talk to our experts.',
  'newsDetail.contactTeam': 'Contact Business Team',
  'newsDetail.shareArticle': 'Share Article',
  'newsDetail.copyLink': 'Copy Link',
  'share.linkCopied': 'Link copied',
  'share.native': 'More sharing options',
  'newsDetail.cta.subtitle': 'Want to explore more Web3 solutions?',
  'newsDetail.cta.title': 'Contact our professional team for a tailored solution',
  'newsDetail.backToList': 'Back to List',
  'breadcrumb.contact': 'Contact',
  'contact.hero.tag': 'Contact Us',
  'contact.hero.title': 'Contact Us',
  'contact.hero.highlight': 'Start the Conversation',
  'contact.hero.desc1': 'Whether you are a startup or an enterprise, our team is ready to provide professional Web3 consulting.',
  'contact.hero.desc2': 'Submit the form or contact us directly, and we usually reply within 24 hours.',
  'contact.hero.card.0.label': 'Email',
  'contact.hero.card.0.val': 'info@geelx.com',
  'contact.hero.card.1.label': '24/7 Support',
  'contact.hero.card.1.val': 'Always Available',
  'contact.hero.card.2.label': 'Avg Response Time',
  'contact.hero.card.2.val': '< 4 Hours',
  'contact.form.captcha': 'Captcha',
  'contact.form.captcha.placeholder': 'Enter captcha',
  'contact.form.captcha.refresh': 'Refresh',
  'contact.form.error.captcha': 'Invalid or expired captcha. Please try again.',
  'contact.form.error.maxChars': 'Message cannot exceed 500 characters.',
  'contact.form.success.title': 'Submitted Successfully!',
  'contact.form.success.desc1': 'Thank you for your message. Our business team will contact you within',
  'contact.form.success.descStrong': '24 hours',
  'contact.form.success.desc2': '.',
  'contact.form.success.desc3': 'Please watch for emails from',
  'contact.form.success.desc4': '.',
  'contact.form.submitAgain': 'Submit Again',
  'contact.form.title': 'Send Inquiry',
  'contact.form.subtitle': 'Fill in the form and we will get back to you soon.',
  'contact.form.name': 'Name',
  'contact.form.name.placeholder': 'Your name',
  'contact.form.company': 'Company',
  'contact.form.company.placeholder': 'Your company (optional)',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone / WhatsApp',
  'contact.form.inquiryType': 'Inquiry Type',
  'contact.form.inquiryType.placeholder': 'Please select...',
  'contact.form.budget': 'Budget Range',
  'contact.form.message': 'Message',
  'contact.form.message.placeholder': 'Briefly describe your project requirements, stage, and expected timeline...',
  'contact.form.message.hint': 'A detailed message helps us match solutions faster.',
  'contact.form.error.submitFailed': 'Submission failed. Please try again later or contact us by email.',
  'contact.form.submitting': 'Submitting...',
  'contact.form.submit': 'Send Inquiry',
  'contact.form.agreePrefix': 'By submitting, you agree to our',
  'contact.form.and': 'and',
  'contact.social': 'Social Media',
  'contact.social.wechat': 'WeChat Official Account',
  'contact.offices.tag': 'Global Offices',
  'contact.offices.title': 'Global Office Network',
  'contact.offices.subtitle': 'Coordinated operation across three locations for fast global response.',
  'contact.faq.tag': 'FAQ',
  'contact.faq.title': 'Frequently Asked Questions',
  'contact.faq.highlight': 'Quick Answers',
  'contact.faq.subtitle': 'These are the most common questions from new clients. Reach out if you need more details.',
  'contact.faq.notFound': "Didn't find your answer?",
  'contact.faq.askExpert': 'Talk directly to our experts',
  'contact.faq.submitForm': 'Submit Inquiry Form',
  'contact.bottom.title': 'Ready to start your Web3 project?',
  'contact.bottom.subtitle': 'Contact us now for a free project assessment and technical recommendations.',
  'contact.bottom.emailUs': 'Email Us',
  'contact.bottom.submitNow': 'Submit Now',
  'contact.inquiry.0': 'CEX Development',
  'contact.inquiry.1': 'RWA Tokenization',
  'contact.inquiry.2': 'Web3 Wallet Development',
  'contact.inquiry.3': 'DeFi Staking Protocol',
  'contact.inquiry.4': 'Mining Hosting Platform',
  'contact.inquiry.5': 'Smart Contract Audit',
  'contact.inquiry.6': 'Enterprise Blockchain Customization',
  'contact.inquiry.7': 'Other',
  'contact.info.address': 'Headquarters',
  'contact.info.email': 'Business Email',
  'contact.info.email.partner': 'Partner: partner@geelx.com',
  'contact.info.email.market': 'Market: market@geelx.com',
  'contact.info.phone': 'Telegram/WhatsApp',
  'contact.info.telegram': 'Telegram: +44 7849923593',
  'contact.info.whatsapp': 'WhatsApp: +44 7849923593',
  'contact.info.hours': 'Working Hours',
  'contact.info.hours.line1': 'Mon-Fri 09:00 – 18:00 SGT',
  'contact.info.hours.line2': 'Technical Support 24/7',
  'contact.office.0.city': 'Singapore (HQ)',
  'contact.office.1.city': 'Hong Kong (Business Center)',
  'contact.office.2.city': 'Shanghai (R&D Collaboration)',
  'contact.office.2.address': '18F, Building at Lujiazui Financial District, Pudong, Shanghai',
  'contact.faq.items.0.q': 'How long from requirement submission to project kickoff?',
  'contact.faq.items.0.a': 'We usually complete requirement assessment within 3-5 working days and provide an initial solution and quotation.',
  'contact.faq.items.1.q': 'What collaboration models do you support?',
  'contact.faq.items.1.a': 'We provide fixed-price projects, monthly technical outsourcing, and strategic tech partnership models.',
  'contact.faq.items.2.q': 'Do you provide source code delivery?',
  'contact.faq.items.2.a': 'Yes. All projects include full source code, documentation, and deployment guides.',
  'contact.faq.items.3.q': 'Can you help with regulatory license application?',
  'contact.faq.items.3.a': 'We work with licensed legal partners in major jurisdictions including Singapore and Hong Kong.',
  'contact.faq.items.4.q': 'Do you provide post-launch support?',
  'contact.faq.items.4.a': 'Standard service includes 3 months of free maintenance with 24/7 online support and bug fixes.',
  'contact.faq.items.5.q': 'Do you support remote collaboration with overseas clients?',
  'contact.faq.items.5.a': 'Absolutely. Most of our clients are overseas and we collaborate efficiently across time zones.',
  'breadcrumb.products': 'Products',
  'breadcrumb.services': 'Services',

  'serviceDetail.outline': 'Outline',
  'serviceDetail.contactHint': 'Have a business need? Talk to our experts',
  'serviceDetail.contactTeam': 'Contact our team',
  'serviceDetail.cta.subtitle': 'Ready to get started?',
  'serviceDetail.cta.title': 'Speak with our experts about your goals',
  'serviceDetail.backToList': 'Back to services',
  'productsPage.hero.tag': 'Product Suite',
  'productsPage.hero.title': 'Products',
  'productsPage.hero.highlight': 'Full-Stack Web3 Solutions',
  'productsPage.hero.desc1': 'Five product lines covering exchange, asset management, decentralized wallet, staking, and mining.',
  'productsPage.hero.desc2': 'From planning to delivery to long-term operations support.',
  'productsPage.hero.chip.cex': 'CEX',
  'productsPage.hero.chip.rwa': 'RWA Solutions',
  'productsPage.hero.chip.wallet': 'Wallet Ecosystem',
  'productsPage.hero.chip.defi': 'DeFi Staking',
  'productsPage.hero.chip.mining': 'Mining Platform',
  'productsOverview.tag': 'Product Lines',
  'productsOverview.title': 'Four Core Product Lines',
  'productsOverview.desc1': 'From trading infrastructure to asset management, covering full Web3 enterprise scenarios,',
  'productsOverview.desc2': 'full lifecycle services: consulting -> development -> operations',
  'productsOverview.cta': 'View Detailed Solution',
  'productsOverview.lines.cex.label': 'Centralized Exchange CEX',
  'productsOverview.lines.cex.desc': 'Full-stack CEX solution with standard, cluster, and enterprise custom editions, powered by a high-performance matching engine.',
  'productsOverview.lines.cex.tags.0': 'Standard Monolith',
  'productsOverview.lines.cex.tags.1': 'Cluster Edition',
  'productsOverview.lines.cex.tags.2': 'Enterprise Custom',
  'productsOverview.lines.cex.tags.3': 'PC / H5',
  'productsOverview.lines.cex.stats.0': 'TPS',
  'productsOverview.lines.cex.stats.1': 'SLA',
  'productsOverview.lines.wallet.label': 'Wallet + IM Ecosystem',
  'productsOverview.lines.wallet.desc': 'Web3 decentralized wallet app with Wallet+IM integration and web support for one-stop management across 80+ chains.',
  'productsOverview.lines.wallet.tags.0': 'App Wallet',
  'productsOverview.lines.wallet.tags.1': 'Wallet + IM',
  'productsOverview.lines.wallet.tags.2': 'Web Version',
  'productsOverview.lines.wallet.stats.0': 'Chains',
  'productsOverview.lines.wallet.stats.1': 'Platforms',
  'productsOverview.lines.rwa.label': 'RWA Tokenization',
  'productsOverview.lines.rwa.desc': 'Tokenize real-world assets such as real estate, art, supply chain assets, and private equity with a three-layer architecture.',
  'productsOverview.lines.rwa.tags.0': 'Real Estate',
  'productsOverview.lines.rwa.tags.1': 'Art',
  'productsOverview.lines.rwa.tags.2': 'Supply Chain',
  'productsOverview.lines.rwa.tags.3': 'Private Equity',
  'productsOverview.lines.rwa.stats.0': 'Layers',
  'productsOverview.lines.rwa.stats.1': 'Jurisdictions',
  'productsOverview.lines.dapp.label': 'DeFi Staking & Mining',
  'productsOverview.lines.dapp.desc': 'Custom development for staking systems, mining platforms, NFT markets, gaming DApps, and private-sale platforms with source delivery.',
  'productsOverview.lines.dapp.tags.0': 'Staking System',
  'productsOverview.lines.dapp.tags.1': 'Mining Platform',
  'productsOverview.lines.dapp.tags.2': 'NFT',
  'productsOverview.lines.dapp.tags.3': 'Gaming DApp',
  'productsOverview.lines.dapp.stats.0': 'Delivery',
  'productsOverview.lines.dapp.stats.1': 'Support',
  'productsLifecycle.quick.title': 'Five Product Lines, Quick Access',
  'productsLifecycle.quick.subtitle': 'Choose the product category you are interested in and view the full technical solution',
  'productsLifecycle.tag': 'Full Lifecycle',
  'productsLifecycle.title': 'Full Lifecycle Services',
  'productsLifecycle.desc': 'From initial consulting to continuous operations, each phase is backed by expert teams to bring your Web3 project from idea to commercialization.',
  'productsLifecycle.stepPrefix': 'STEP',
  'productsLifecycle.steps.0.title': 'Requirement Consulting',
  'productsLifecycle.steps.0.desc': 'Business analysis and technical selection guidance with complete solution documents and quotation',
  'productsLifecycle.steps.0.duration': '3-5 business days',
  'productsLifecycle.steps.1.title': 'Architecture Design',
  'productsLifecycle.steps.1.desc': 'System architecture planning, tech stack definition, and UI/UX prototype review',
  'productsLifecycle.steps.1.duration': '1-2 weeks',
  'productsLifecycle.steps.2.title': 'Development Delivery',
  'productsLifecycle.steps.2.desc': 'Agile iterations with a dedicated project manager and staged acceptance',
  'productsLifecycle.steps.2.duration': '4-16 weeks',
  'productsLifecycle.steps.3.title': 'Security Audit',
  'productsLifecycle.steps.3.desc': 'Smart contract audit, penetration testing, and code quality review for secure go-live',
  'productsLifecycle.steps.3.duration': '1-2 weeks',
  'productsLifecycle.steps.4.title': 'Production Launch',
  'productsLifecycle.steps.4.desc': 'Production deployment, stress testing, canary release, and launch monitoring',
  'productsLifecycle.steps.4.duration': '3-7 days',
  'productsLifecycle.steps.5.title': 'Continuous Operations',
  'productsLifecycle.steps.5.desc': '24/7 technical support, system monitoring, version iteration, and feature upgrades',
  'productsLifecycle.steps.5.duration': 'Ongoing service',
  'productsLifecycle.cta.start': 'Start Consulting',
  'productsLifecycle.cta.learn': 'Learn Service Assurance',
  'productsDetail.cex.breadcrumb': 'CEX Exchange',
  'productsDetail.cex.title': 'CEX Exchange',
  'productsDetail.cex.highlight': 'Full-Stack One-Stop Solution',
  'productsDetail.cex.cta': 'Get Solution Quote',
  'productsDetail.cex.desc1': 'From standard monolith to enterprise cluster deployment, and from custom enterprise builds to full PC/H5 coverage,',
  'productsDetail.cex.desc2': 'we provide a high-performance matching engine, KYC/AML compliance modules, and a complete operations framework,',
  'productsDetail.cex.desc3': 'helping you launch fast and scale securely.',
  'productsDetail.cex.tags.0': '100K+ TPS Matching',
  'productsDetail.cex.tags.1': 'KYC/AML Compliance',
  'productsDetail.cex.tags.2': 'PC / H5 / APP',
  'productsDetail.cex.tags.3': '24/7 Operations Support',
  'productsDetail.cex.stats.0.label': 'Peak Matching Performance',
  'productsDetail.cex.stats.1.label': 'System Availability SLA',
  'productsDetail.cex.stats.2.label': 'Order Response Latency',
  'productsDetail.cex.stats.3.unit': 'cases',
  'productsDetail.cex.stats.3.label': 'Successful Global Launches',
  'productsDetail.cex.tabs.standard': 'Standard Monolith',
  'productsDetail.cex.tabs.cluster': 'Cluster Edition',
  'productsDetail.cex.tabs.custom': 'Enterprise Custom',
  'productsDetail.cex.tabs.pc': 'PC Terminal',
  'productsDetail.cex.tabs.h5': 'H5 Mobile',
  'productsDetail.rwa.breadcrumb': 'RWA Tokenization',
  'productsDetail.rwa.title': 'RWA Tokenization',
  'productsDetail.rwa.highlight': 'On-Chain Compliant Issuance Platform',
  'productsDetail.rwa.cta': 'Get Compliance Quote',
  'productsDetail.rwa.desc1': 'Map real-world assets (real estate, equity, bonds, commodities) onto blockchain,',
  'productsDetail.rwa.desc2': 'build a full-lifecycle digital securities platform for issuance, circulation, and settlement under major jurisdictions,',
  'productsDetail.rwa.desc3': 'and unlock liquidity between traditional finance and Web3.',
  'productsDetail.rwa.tags.0': 'Multi-Jurisdiction Compliance',
  'productsDetail.rwa.tags.1': 'STO Standard',
  'productsDetail.rwa.tags.2': 'Secondary Trading Market',
  'productsDetail.rwa.tags.3': 'Smart Contract Audits',
  'productsDetail.rwa.stats.0.unit': 'types',
  'productsDetail.rwa.stats.0.label': 'Supported Asset Types',
  'productsDetail.rwa.stats.1.label': 'Total Tokenized Volume',
  'productsDetail.rwa.stats.2.unit': 'regions',
  'productsDetail.rwa.stats.2.label': 'Compliance Coverage',
  'productsDetail.rwa.stats.3.unit': 'projects',
  'productsDetail.rwa.stats.3.label': 'Successful Global Issuances',
  'productsDetail.rwa.tabs.compliance': 'Compliance Framework',
  'productsDetail.rwa.tabs.architecture': 'Technical Architecture',
  'productsDetail.rwa.tabs.assetTypes': 'Asset Types',
  'productsDetail.rwa.tabs.issuance': 'Issuance Flow',
  'productsDetail.rwa.tabs.market': 'Secondary Market',
  'productsDetail.wallet.breadcrumb': 'Web3 Wallet',
  'productsDetail.wallet.title': 'Web3 Multichain Wallet',
  'productsDetail.wallet.highlight': 'Integrated Asset Management Gateway',
  'productsDetail.wallet.cta': 'Get Wallet Solution',
  'productsDetail.wallet.desc1': 'Supports 100+ mainstream chains with MPC security and built-in DApp browser,',
  'productsDetail.wallet.desc2': 'integrating cross-chain swaps and enterprise-grade custody,',
  'productsDetail.wallet.desc3': 'to provide a professional Web3 gateway for both retail users and institutions.',
  'productsDetail.wallet.tags.0': '100+ Chains',
  'productsDetail.wallet.tags.1': 'MPC Security',
  'productsDetail.wallet.tags.2': 'DApp Browser',
  'productsDetail.wallet.tags.3': 'Cross-Chain Swap',
  'productsDetail.wallet.stats.0.unit': 'chains',
  'productsDetail.wallet.stats.0.label': 'Supported Chains',
  'productsDetail.wallet.stats.1.unit': 'users',
  'productsDetail.wallet.stats.1.label': 'Global Active Users',
  'productsDetail.wallet.stats.2.unit': 'apps',
  'productsDetail.wallet.stats.2.label': 'Integrated DApps',
  'productsDetail.wallet.stats.3.unit': 'incidents',
  'productsDetail.wallet.stats.3.label': 'Security Vulnerabilities',
  'productsDetail.wallet.tabs.multichain': 'Multichain Support',
  'productsDetail.wallet.tabs.security': 'Security System',
  'productsDetail.wallet.tabs.dapp': 'DApp Ecosystem',
  'productsDetail.wallet.tabs.enterprise': 'Enterprise Wallet',
  'productsDetail.wallet.tabs.sdk': 'Developer SDK',
  'productsDetail.defi.breadcrumb': 'DeFi Staking Protocol',
  'productsDetail.defi.title': 'DeFi Staking Protocol',
  'productsDetail.defi.highlight': 'High-Yield Liquidity Full-Stack Solution',
  'productsDetail.defi.cta': 'Get DeFi Solution',
  'productsDetail.defi.desc1': 'From PoS staking and AMM liquidity mining to yield aggregators, plus cross-chain bridges and DAO governance,',
  'productsDetail.defi.desc2': 'we provide complete DeFi protocol development and deployment services,',
  'productsDetail.defi.desc3': 'helping users grow assets while continuously deepening platform liquidity.',
  'productsDetail.defi.tags.0': 'PoS Staking',
  'productsDetail.defi.tags.1': 'AMM Liquidity',
  'productsDetail.defi.tags.2': 'Yield Aggregation',
  'productsDetail.defi.tags.3': 'Cross-Chain Bridge',
  'productsDetail.defi.stats.0.label': 'Total Value Locked (TVL)',
  'productsDetail.defi.stats.1.label': 'Max APY',
  'productsDetail.defi.stats.2.unit': 'protocols',
  'productsDetail.defi.stats.2.label': 'Deployed DeFi Protocols',
  'productsDetail.defi.stats.3.unit': 'pairs',
  'productsDetail.defi.stats.3.label': 'Supported Trading Pairs',
  'productsDetail.defi.tabs.protocol': 'Staking Protocol',
  'productsDetail.defi.tabs.liquidity': 'Liquidity Mining',
  'productsDetail.defi.tabs.aggregator': 'Yield Aggregator',
  'productsDetail.defi.tabs.bridge': 'Cross-Chain Bridge',
  'productsDetail.defi.tabs.governance': 'Governance Voting',
  'productsDetail.mining.breadcrumb': 'Cloud Mining',
  'productsDetail.mining.title': 'Cloud Mining Platform',
  'productsDetail.mining.highlight': 'Hashrate as a Service, Mine Anytime',
  'productsDetail.mining.cta': 'Get Mining Solution',
  'productsDetail.mining.desc1': 'Provide one-stop cloud hashrate platform setup for mainstream coins including BTC/ETH/LTC,',
  'productsDetail.mining.desc2': 'covering package management, mining pool access, automated settlement, and data center hosting,',
  'productsDetail.mining.desc3': 'so anyone can easily participate in crypto mining.',
  'productsDetail.mining.tags.0': 'Hashrate Leasing',
  'productsDetail.mining.tags.1': 'Mining Pool System',
  'productsDetail.mining.tags.2': 'Auto Settlement',
  'productsDetail.mining.tags.3': 'Data Center Hosting',
  'productsDetail.mining.stats.0.label': 'Total Platform Hashrate',
  'productsDetail.mining.stats.1.label': 'Miner Uptime Guarantee',
  'productsDetail.mining.stats.2.unit': 'regions',
  'productsDetail.mining.stats.2.label': 'Global Data Center Nodes',
  'productsDetail.mining.stats.3.label': 'Ultra-Low PUE',
  'productsDetail.mining.tabs.hashrate': 'Hashrate Packages',
  'productsDetail.mining.tabs.infrastructure': 'Data Center Infrastructure',
  'productsDetail.mining.tabs.pool': 'Mining Pool System',
  'productsDetail.mining.tabs.earnings': 'Earnings Settlement',
  'productsDetail.mining.tabs.colocation': 'Colocation Plan',
  'productsCta.back': 'Back to Products',
  'productsCta.cex.tag': 'Ready to Launch?',
  'productsCta.cex.title': 'Ready to launch your exchange?',
  'productsCta.cex.desc1': 'From requirement alignment to go-live, our team supports you end-to-end.',
  'productsCta.cex.desc2': 'Standard deployment can be completed in as fast as 4 weeks.',
  'productsCta.cex.quote': 'Get CEX Quote',
  'productsCta.cex.badge.0': 'Full Source Delivery',
  'productsCta.cex.badge.1': 'Security Audited',
  'productsCta.cex.badge.2': '24/7 Tech Support',
  'productsCta.cex.badge.3': 'Compliance-Ready Docs',
  'productsCta.rwa.tag': 'Ready to Tokenize?',
  'productsCta.rwa.title': 'Ready to tokenize your assets?',
  'productsCta.rwa.desc1': 'From legal structuring to smart contract deployment and listing,',
  'productsCta.rwa.desc2': 'our team can complete the full issuance process in 10-18 weeks.',
  'productsCta.rwa.quote': 'Get RWA Quote',
  'productsCta.rwa.badge.0': 'Compliance Certification',
  'productsCta.rwa.badge.1': 'Contract Auditing',
  'productsCta.rwa.badge.2': '15+ Jurisdictions',
  'productsCta.rwa.badge.3': 'Complete Legal Docs',
  'productsCta.wallet.tag': 'Launch Your Wallet',
  'productsCta.wallet.title': 'Build your Web3 wallet brand',
  'productsCta.wallet.desc1': 'From white-label SDK to full customization, launch in as fast as 2 weeks.',
  'productsCta.wallet.desc2': 'Includes full source delivery and App Store listing assistance.',
  'productsCta.wallet.quote': 'Get Wallet Quote',
  'productsCta.wallet.badge.0': '100+ Chains Supported',
  'productsCta.wallet.badge.1': 'Top-Tier Security Audit',
  'productsCta.wallet.badge.2': 'Complete SDK Delivery',
  'productsCta.wallet.badge.3': '500+ DApp Ecosystem',
  'productsCta.defi.tag': 'Launch Your DeFi Protocol',
  'productsCta.defi.title': 'Build your DeFi yield ecosystem',
  'productsCta.defi.desc1': 'From staking and AMM liquidity to cross-chain bridge and DAO governance,',
  'productsCta.defi.desc2': 'we deliver a security-audited DeFi stack to help you scale TVL quickly.',
  'productsCta.defi.quote': 'Get DeFi Quote',
  'productsCta.defi.badge.0': '3rd-Party Contract Audits',
  'productsCta.defi.badge.1': '4 Staking Models',
  'productsCta.defi.badge.2': '40+ Cross-Chain Bridges',
  'productsCta.defi.badge.3': 'DAO Governance',
  'productsCta.mining.tag': 'Start Mining Today',
  'productsCta.mining.title': 'Build your cloud mining platform',
  'productsCta.mining.desc1': 'From hashrate packages to pool systems and infrastructure settlement,',
  'productsCta.mining.desc2': 'we provide an end-to-end cloud mining solution,',
  'productsCta.mining.desc3': 'with white-label customization and launch in as fast as 6 weeks.',
  'productsCta.mining.quote': 'Get Mining Quote',
  'productsCta.mining.badge.0': '100 EH/s+ Hashrate',
  'productsCta.mining.badge.1': '5 Global Facilities',
  'productsCta.mining.badge.2': '100% Clean Energy',
  'productsCta.mining.badge.3': 'Daily Auto Settlement',
  'breadcrumb.advantages': 'Core Advantages',
  'advantages.hero.tag': 'Core Advantages',
  'advantages.hero.title': 'Core Advantages',
  'advantages.hero.highlight': 'Why Choose Us',
  'advantages.hero.desc1': 'With 8+ years of industry accumulation, our five core strengths build a hard-to-replicate technical and service moat,',
  'advantages.hero.desc2': 'ensuring your Web3 business is protected from launch to large-scale growth.',
  'advantages.hero.pill.0': 'Modular Architecture',
  'advantages.hero.pill.1': 'Public Chain Ecosystem',
  'advantages.hero.pill.2': 'Innovation-Driven',
  'advantages.hero.pill.3': 'Security & Compliance',
  'advantages.hero.pill.4': 'Client-Oriented',
  'advantages.s1.tag1': 'Modular Architecture',
  'advantages.s1.title1': 'Highly Modular,',
  'advantages.s1.title1h': 'Flexible Expansion',
  'advantages.s1.desc1': 'Our full-stack solutions are built on microservices plus modular architecture, with independently packaged and freely combinable modules.',
  'advantages.s1.desc2': 'Whether you need a complete CEX system or only specific modules like matching engine or KYC, you can choose by demand,',
  'advantages.s1.desc3': 'significantly reducing early investment and enabling seamless scaling as your business grows.',
  'advantages.s1.p1.0': 'Independent module deployment, where single-module failures do not impact the whole system',
  'advantages.s1.p1.1': 'On-demand assembly: purchase a standalone CEX engine or full suite',
  'advantages.s1.p1.2': 'Hot updates and canary releases for zero-downtime upgrades',
  'advantages.s1.p1.3': 'Standardized APIs for easy third-party integration',
  'advantages.s1.p1.4': 'Microservice architecture for horizontal scaling under traffic surges',
  'advantages.s1.stat1': 'Module Reuse Rate',
  'advantages.s1.stat2': 'Iteration Speed Gain',
  'advantages.s1.stat3': 'O&M Cost Reduction',
  'advantages.s1.badge1': 'Modular Architecture',
  'advantages.s1.badge1d': 'On-Demand Assembly · Independent Deployment',
  'advantages.s1.badge2': 'Multi-Chain Interoperability',
  'advantages.s1.badge2d': '15+ Mainstream Chains Supported',
  'advantages.s1.tag2': 'Complete Public Chain Coverage',
  'advantages.s1.title2': 'Multi-Chain Parallelism,',
  'advantages.s1.title2h': 'Ecosystem-Wide Coverage',
  'advantages.s1.desc4': 'We deeply support 15+ mainstream public chains with full cross-chain interoperability capabilities.',
  'advantages.s1.desc5': 'Whether your business runs in Ethereum DeFi ecosystems, Solana high-frequency scenarios,',
  'advantages.s1.desc6': 'or TRON stablecoin payment scenarios, we have mature solutions and proven case studies.',
  'advantages.s1.p2.0': 'Deep support for major chains such as ETH, BSC, Solana, and TRON',
  'advantages.s1.p2.1': 'Cross-chain bridge protocols for seamless multi-chain asset transfer',
  'advantages.s1.p2.2': 'Layer 2 integration (Arbitrum, Optimism, ZK-Rollup)',
  'advantages.s1.p2.3': 'Hybrid consortium-chain + public-chain architecture for compliance and decentralization',
  'advantages.s1.p2.4': 'Unified multi-chain wallet management to lower user operation thresholds',
  'advantages.s2.tag1': 'Innovation-Driven',
  'advantages.s2.title1': 'Technology Frontier,',
  'advantages.s2.title1h': 'Continuous Leadership',
  'advantages.s2.desc1': 'We continuously track and invest in frontier Web3 technologies, integrating capabilities such as ZK Proof, Layer2, and AI risk control',
  'advantages.s2.desc2': 'into our product system to keep clients at the forefront rather than playing catch-up.',
  'advantages.s2.inno.0.t': 'ZK Proof Applications',
  'advantages.s2.inno.0.d': 'Zero-knowledge proof technology enables compliant verification while preserving user privacy for both security and UX.',
  'advantages.s2.inno.1.t': 'Layer 2 Optimization',
  'advantages.s2.inno.1.d': 'Deep integration with Arbitrum, Optimism, and ZK-Rollup reduces gas cost by 90%+ and boosts TPS significantly.',
  'advantages.s2.inno.2.t': 'AI Intelligent Risk Control',
  'advantages.s2.inno.2.d': 'Machine learning models embedded in risk engines detect anomalous transactions in real time, with false-positive rates below 0.1%.',
  'advantages.s2.inno.3.t': 'NFT Infrastructure',
  'advantages.s2.inno.3.d': 'Complete NFT minting, trading, fractionalization, and staking system supporting ERC-721/1155 standards.',
  'advantages.s2.rd': 'R&D Investment',
  'advantages.s2.rd1': 'Revenue Invested in R&D',
  'advantages.s2.rd2': 'Core Technology Patents',
  'advantages.s2.rd3': 'Technical Engineers',
  'advantages.s2.badge': 'Multi-Layer Security',
  'advantages.s2.badged': 'Zero-Critical-Vulnerability Launch Commitment',
  'advantages.s2.tag2': 'Security & Compliance',
  'advantages.s2.title2': 'Security First,',
  'advantages.s2.title2h': 'Global Compliance Coverage',
  'advantages.s2.desc3': 'As security incidents remain frequent and compliance requirements become stricter, we built an industry-leading multi-layer security audit system,',
  'advantages.s2.desc4': 'while deeply researching major global regulatory frameworks to help clients operate steadily on a compliant track.',
  'advantages.s2.compTitle': 'Jurisdictions Covered',
  'advantages.s2.comp.0.r': 'Singapore',
  'advantages.s2.comp.0.d': 'Payment Services Act (PSA) compliance framework and digital payment token licensing guidance',
  'advantages.s2.comp.1.r': 'Hong Kong',
  'advantages.s2.comp.1.d': 'Virtual Asset Service Provider (VASP) licensing framework and compliant security-token issuance',
  'advantages.s2.comp.2.r': 'European Union',
  'advantages.s2.comp.2.d': 'MiCA compliance assessment and system adaptation',
  'advantages.s2.comp.3.r': 'United States',
  'advantages.s2.comp.3.d': 'AML/KYC compliance framework setup and MSB license application support',
  'advantages.s2.comp.4.r': 'Cayman Islands',
  'advantages.s2.comp.4.d': 'Compliance architecture design for offshore funds and DeFi protocols',
  'advantages.s2.comp.5.r': 'British Virgin Islands',
  'advantages.s2.comp.5.d': 'Offshore company registration and compliant operations support for Web3 projects',
  'advantages.s3.tag': 'Client-Centric & Ecosystem Co-Growth',
  'advantages.s3.title1': 'Client Success Is',
  'advantages.s3.title2': 'Our Only Goal',
  'advantages.s3.desc1': 'We are not just a technical vendor, but your long-term strategic technology partner.',
  'advantages.s3.desc2': 'The success of every client is our most valuable proof of brand value.',
  'advantages.s3.benefit.0.title': 'Dedicated Project Manager',
  'advantages.s3.benefit.0.desc': 'Each project is assigned one dedicated PM to track requirements, progress, and launch with a unified communication window.',
  'advantages.s3.benefit.1.title': '30-Minute Response Commitment',
  'advantages.s3.benefit.1.desc': 'Critical system issues are responded to within 30 minutes and production incidents fixed within 2 hours, backed by contractual SLA.',
  'advantages.s3.benefit.2.title': 'Ecosystem Resource Matching',
  'advantages.s3.benefit.2.desc': 'We connect clients with law firms, market makers, exchanges, and media resources to accelerate business opportunities.',
  'advantages.s3.benefit.3.title': 'Success-Oriented Delivery',
  'advantages.s3.benefit.3.desc': 'Our success is tightly tied to client business success. Client outcomes are our most valuable brand assets.',
  'advantages.s3.compareTitle': 'Comparison with Typical Vendors',
  'advantages.s3.compareCol.0': 'Capability',
  'advantages.s3.compareCol.1': 'Us',
  'advantages.s3.compareCol.2': 'Typical Vendor',
  'advantages.s3.compare.0': 'Modular Architecture',
  'advantages.s3.compare.1': '15+ Public Chains Supported',
  'advantages.s3.compare.2': 'ZK/Layer2 Integration',
  'advantages.s3.compare.3': 'Global Compliance Coverage',
  'advantages.s3.compare.4': 'Dedicated PM',
  'advantages.s3.compare.5': 'Full Source Code Delivery',
  'advantages.s3.compare.6': '24/7 Technical Support',
  'advantages.s3.compare.7': 'Ecosystem Resource Matching',
  'advantages.s3.cta.title': 'Ready to Get Started?',
  'advantages.s3.cta.desc': 'We are your most reliable technology partner for Web3 business.',
  'advantages.s3.cta.btn2': 'Browse Product Suite',
  'aboutPage.mission.badge': 'Registered in Singapore',
  'aboutPage.mission.cardTitle': 'Our Mission',
  'aboutPage.mission.cardDesc1': 'Transform complex blockchain technology into executable enterprise productivity,',
  'aboutPage.mission.cardDesc2': 'so Web3 can truly serve the real economy.',
  'aboutPage.mission.tag': 'Origin & Mission',
  'aboutPage.mission.title1': 'Born at the',
  'aboutPage.mission.title2': 'Dawn of Blockchain',
  'aboutPage.mission.p1': 'In 2023, our founding team registered the company in Singapore when blockchain technology was still emerging. We believed this technology would fundamentally reshape global finance and the real economy.',
  'aboutPage.mission.p2': 'We witnessed the full evolution from Bitcoin to Ethereum smart contracts, from DeFi to NFT, and then to RWA tokenization. In every wave, we built deep hands-on experience.',
  'aboutPage.mission.p3.prefix': 'Our mission remains unchanged:',
  'aboutPage.mission.p3.strong': 'turn complex blockchain technology into practical enterprise productivity',
  'aboutPage.mission.p3.suffix': ', and provide every Web3-transforming enterprise with professional, efficient, and secure technical support.',
  'aboutPage.mission.timeline.0.year': '2023',
  'aboutPage.mission.timeline.0.event': 'Founding team entered the blockchain field and focused on related research',
  'aboutPage.mission.timeline.1.year': '2024',
  'aboutPage.mission.timeline.1.event': 'Launched our first full-stack CEX solution',
  'aboutPage.mission.timeline.2.year': '2025',
  'aboutPage.mission.timeline.2.event': 'Expanded fully into DApp, wallet, and IM product lines during the DeFi wave',
  'aboutPage.mission.timeline.3.year': '2025',
  'aboutPage.mission.timeline.3.event': 'Officially launched RWA solutions to pioneer real-world asset tokenization and registered the company in Singapore',
  'aboutPage.mission.timeline.4.year': '2026',
  'aboutPage.mission.timeline.4.event': 'Served global enterprise clients and became a benchmark Web3 full-stack service provider',
  'aboutPage.values.tag': 'Core Values & Differentiation',
  'aboutPage.values.title': 'Our Core Values',
  'aboutPage.values.subtitle': 'With eight years of focus, our three core values drive every product decision and service action.',
  'aboutPage.values.v0.title': 'Technology as a Service',
  'aboutPage.values.v0.subtitle': 'Technology as a Service',
  'aboutPage.values.v0.desc': 'We are not merely outsourcing vendors; we are true technology partners. From strategy planning to execution, we participate deeply with client success as the only goal.',
  'aboutPage.values.v0.f0': 'Dedicated Technical Advisor',
  'aboutPage.values.v0.f1': 'Deep Business Understanding',
  'aboutPage.values.v0.f2': 'Long-Term Partnership',
  'aboutPage.values.v1.title': 'Industry + Web3 Integration',
  'aboutPage.values.v1.subtitle': 'Industry × Web3 Integration',
  'aboutPage.values.v1.desc': 'We focus on deeply integrating traditional industries with Web3, not speculative crypto narratives. Every solution starts from real business scenarios to create tangible value.',
  'aboutPage.values.v1.f0': 'RWA Tokenization',
  'aboutPage.values.v1.f1': 'On-Chain Supply Chain Finance',
  'aboutPage.values.v1.f2': 'Compliant Digital Asset Issuance',
  'aboutPage.values.v2.title': 'Full Lifecycle Support',
  'aboutPage.values.v2.subtitle': 'Full Lifecycle Support',
  'aboutPage.values.v2.desc': 'From strategic consulting, architecture design, system development, and launch deployment to continuous operation and iterative upgrades, we provide end-to-end support.',
  'aboutPage.values.v2.f0': 'Consulting -> Development -> Operations',
  'aboutPage.values.v2.f1': 'Full Source Delivery',
  'aboutPage.values.v2.f2': 'After-Sales Support System',
  'aboutPage.values.diffTitle': 'What Makes Us Different',
  'aboutPage.values.d0.title': 'Full-Stack Product Matrix',
  'aboutPage.values.d0.desc': 'CEX + RWA + Wallet + DApp support for virtually all Web3 business scenarios',
  'aboutPage.values.d1.title': 'Multi-Jurisdiction Compliance',
  'aboutPage.values.d1.desc': 'Deep understanding of major frameworks such as Singapore MAS and Hong Kong SFC to ensure compliant operations',
  'aboutPage.values.d2.title': 'Flexible Modular Assembly',
  'aboutPage.values.d2.desc': 'Independent module deployment and free combination for tailored implementation and rapid business adaptation',
  'aboutPage.values.d3.title': '24/7 Dedicated Support',
  'aboutPage.values.d3.desc': 'Dedicated PM + around-the-clock technical team, with responses within 30 minutes for any issue',
  'aboutPage.commit.tag': 'Commitments & Guarantees',
  'aboutPage.commit.title': 'Our Service Commitments',
  'aboutPage.commit.subtitle': 'Every commitment is contractually enforceable to protect your rights.',
  'aboutPage.commit.c0.title': 'Complete Source Code Delivery',
  'aboutPage.commit.c0.desc': 'All custom development projects include full source code delivery, so clients fully control their technical assets without lock-in risk.',
  'aboutPage.commit.c1.title': 'Multi-Layer Security Audits',
  'aboutPage.commit.c1.desc': 'Our security team is involved throughout with code auditing, vulnerability scanning, and penetration testing.',
  'aboutPage.commit.c2.title': 'Dedicated Project Manager',
  'aboutPage.commit.c2.desc': 'Every project is assigned a dedicated PM to track requirements, progress, and quality from start to finish.',
  'aboutPage.commit.c3.title': '24/7 Technical Support',
  'aboutPage.commit.c3.desc': 'Our technical team is on standby at all times, with critical issues responded to in 30 minutes.',
  'aboutPage.commit.c4.title': 'Compliant Invoicing',
  'aboutPage.commit.c4.desc': 'As a Singapore-registered company, we provide compliant invoices and multiple payment options.',
  'aboutPage.commit.c5.title': 'Continuous Iteration & Upgrades',
  'aboutPage.commit.c5.desc': 'Delivery is not the end. We offer long-term maintenance contracts for ongoing upgrades as your business evolves.',
  'aboutPage.future.tag': 'Looking Ahead',
  'aboutPage.future.title1': 'Become a Global Leader in',
  'aboutPage.future.title2': 'Industrial Blockchain Services',
  'aboutPage.future.desc1': 'Over the next five years, we will continue deep investment in RWA tokenization and help more traditional industries complete Web3 transformation.',
  'aboutPage.future.desc2': 'Amid global compliance trends, we help clients seize opportunities and jointly build a fairer, more transparent, and more efficient digital economic infrastructure.',
  'aboutPage.future.btn1': 'Start Collaboration Now',
  'aboutPage.future.btn2': 'View Core Advantages',

  'seo.brand': 'GEEL TEC',
  'seo.home.title': 'Industrial Blockchain & Web3 Solutions | GEEL TEC',
  'seo.home.desc':
    'Singapore-based team delivering CEX, RWA, wallets, and custom DApps for enterprise Web3.',
  'seo.home.keywords':
    'GEEL TEC, industrial blockchain, Web3, enterprise blockchain, Singapore, CEX, RWA, crypto wallet, DApp, smart contract',
  'seo.about.title': 'About Us',
  'seo.about.desc':
    'Industrial blockchain and Web3 technology company headquartered in Singapore, focused on full-stack solutions and compliant delivery.',
  'seo.about.keywords':
    'GEEL TEC, about us, Singapore company, blockchain company, Web3 consulting, compliance, enterprise blockchain',
  'seo.advantages.title': 'Why Us',
  'seo.advantages.desc':
    'Modular architecture, multi-chain coverage, security and compliance, and 24/7 support for production-grade Web3.',
  'seo.advantages.keywords':
    'GEEL TEC, advantages, modular architecture, multi-chain, security compliance, 24/7 support, Web3 adoption',
  'seo.products.title': 'Products',
  'seo.products.desc':
    'Modular CEX, RWA, wallet, DeFi/DApp, and mining-related systems—compose and ship faster with enterprise SLAs.',
  'seo.products.keywords':
    'GEEL TEC, products, CEX, RWA, wallet, DeFi, DApp, mining, blockchain platform',
  'seo.products.cex.title': 'Centralized Exchange (CEX)',
  'seo.products.cex.desc':
    'High-performance matching, KYC/AML, and multi-terminal exchange platforms built for scale.',
  'seo.products.cex.keywords': 'GEEL TEC, CEX, centralized exchange, matching engine, KYC, AML, exchange software',
  'seo.products.rwa.title': 'RWA Solutions',
  'seo.products.rwa.desc':
    'Tokenize real-world assets with compliant workflows, on-chain distribution, and investor-ready reporting.',
  'seo.products.rwa.keywords':
    'GEEL TEC, RWA, real world asset tokenization, asset tokenization, compliant tokenization, digital assets',
  'seo.products.wallet.title': 'Wallet Products',
  'seo.products.wallet.desc':
    'Multi-chain wallets, DApp browsers, and IM-ready experiences with white-label and deep customization.',
  'seo.products.wallet.keywords':
    'GEEL TEC, crypto wallet, multi-chain wallet, DApp browser, white-label wallet, Web3 wallet',
  'seo.products.defi.title': 'DeFi & Staking',
  'seo.products.defi.desc':
    'Staking, liquidity mining, and on-chain incentive modules designed for security and auditability.',
  'seo.products.defi.keywords':
    'GEEL TEC, DeFi, staking, liquidity mining, on-chain incentives, smart contracts, DApp development',
  'seo.products.mining.title': 'Mining Products',
  'seo.products.mining.desc':
    'Mining pool, hashrate, and reward-related infrastructure for institutional-grade deployments.',
  'seo.products.mining.keywords':
    'GEEL TEC, mining, mining pool, hashrate, institutional mining, blockchain infrastructure',
  'seo.news.title': 'News',
  'seo.news.desc': 'Product updates, industry notes, and announcements from the GEEL TEC team.',
  'seo.news.keywords': 'GEEL TEC, news, blockchain news, Web3 updates, product updates, industry insights',
  'seo.newsDetail.title': 'Article',
  'seo.newsDetail.desc': 'Read GEEL TEC articles and updates on enterprise blockchain and Web3.',
  'seo.newsDetail.keywords': 'GEEL TEC, article, blockchain blog, Web3, deep dive',
  'seo.contact.title': 'Contact',
  'seo.contact.desc':
    'Talk to our team about solutions, integrations, and compliance paths for your Web3 roadmap.',
  'seo.contact.keywords':
    'GEEL TEC, contact, business inquiry, technical support, compliance consulting, Web3 partnership',
  'seo.notFound.title': 'Page Not Found',
  'seo.notFound.desc': 'The page you opened does not exist or has moved. Use the navigation to continue.',
  'seo.notFound.keywords': 'GEEL TEC, 404, page not found',
};
